// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__BS8hu","selects":"Documents_selects__zxvyf"};